import { Component } from '@angular/core';

@Component({
    selector: 'app-acesso-em-breve',
    imports: [],
    templateUrl: './acesso-em-breve.html',
    styleUrl: './acesso-em-breve.scss'
})
export class AcessoEmBreve {}
